module.exports = __webpack_public_path__ + "static/media/NDVI.2663fd86.png";